/**
 * Normalize an axios error's FastAPI `detail` into RENDERABLE text.
 *
 * A 422 validation error's detail is an ARRAY of objects
 * ({type, loc, msg, input}) — rendering it raw as a React child throws
 * error #31 and takes the whole page to the error boundary (the
 * 2026-08-13 /send-esign crash). Always returns a string.
 */
export function apiErrorText(err, fallback) {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string' && d) return d;
  if (Array.isArray(d)) {
    const msgs = d
      .map((x) => (x && typeof x === 'object' ? x.msg : String(x)))
      .filter(Boolean);
    if (msgs.length) return msgs.join('; ');
  }
  if (d && typeof d === 'object') {
    try { return JSON.stringify(d); } catch { /* fall through */ }
  }
  return fallback;
}
